import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2020十大重庆经济年度人物评选';
const baseUrl = '20210323JJRWPX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/rules`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rules.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },

    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
